import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type UpdateLooseCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateLooseCargoItemInput;
}>;

export type UpdateLooseCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoUpdateLooseCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateLooseCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<
            GraphQLTypes.CargoContainerType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<
            GraphQLTypes.CargoLooseCargoType,
            | 'containerNumber'
            | 'palletType'
            | 'stackable'
            | 'trailerId'
            | 'cbm'
            | 'hazardous'
            | 'id'
            | 'looseCargoType'
            | 'quantity'
            | 'reefer'
            | 'type'
          > & {
              chargeableWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
              dimensions?: GraphQLTypes.Maybe<
                { __typename?: 'CargoDimensionsType' } & Pick<
                  GraphQLTypes.CargoDimensionsType,
                  'height' | 'length' | 'metric' | 'width'
                >
              >;
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoVehicleType' } & Pick<
            GraphQLTypes.CargoVehicleType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateLooseCargoItemDocument = gql`
  mutation updateLooseCargoItem($input: UpdateLooseCargoItemInput!) {
    cargoUpdateLooseCargoItem(input: $input) {
      cargoItem {
        cbm
        grossWeight {
          metric
          value
        }
        hazardous
        id
        looseCargoType
        quantity
        reefer
        type
        ... on CargoLooseCargoType {
          chargeableWeight {
            metric
            value
          }
          containerNumber
          dimensions {
            height
            length
            metric
            width
          }
          palletType
          stackable
          trailerId
        }
      }
      errors {
        message
        path
      }
    }
  }
`;
